
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.744 8.582c-.779 0-1.505.311-1.869.948-.376-.636-1.039-.948-1.883-.948-1.324 0-2.389.895-2.389 2.518v3.803c0 .299.221.532.519.532.286 0 .52-.234.52-.532v-3.816c0-1.025.597-1.545 1.35-1.545.765 0 1.362.52 1.362 1.545v3.816c0 .299.221.532.52.532a.524.524 0 00.519-.532v-3.816c0-1.025.597-1.545 1.35-1.545.766 0 1.364.52 1.364 1.545v3.816c0 .299.22.532.519.532a.524.524 0 00.519-.532V11.1c0-1.623-1.064-2.518-2.402-2.518zM13.423 8.608a.513.513 0 00-.519.519v5.777c0 .299.221.532.519.532.286 0 .52-.234.52-.532V9.127a.521.521 0 00-.52-.519zM13.423 6.453a.643.643 0 00-.649.649c0 .351.285.65.649.65a.66.66 0 00.649-.65.65.65 0 00-.649-.649zM18.54 8.582c-1.585 0-2.843 1.116-2.843 2.998v3.323c0 .299.221.532.519.532.286 0 .52-.234.52-.532v-3.349c0-1.324.804-2.012 1.804-2.012 1.013 0 1.817.688 1.817 2.012v3.349c0 .299.221.532.519.532.286 0 .52-.234.52-.532V11.58c0-1.882-1.26-2.998-2.856-2.998z"}})])
          )
        }
      }
    